import React from "react";
import { Input } from "../../../../components/ui/input";
import { useDispatch, useSelector } from "react-redux";
import { setLanguageSearchQuery } from "../../../../redux/slices/filterSlice";

function LanguageSearchInput() {
  const dispatch = useDispatch();
  const { languageSearchQuery } = useSelector((state) => state.filters);

  return (
    <div className="flex w-full flex-col gap-2 items-start">
      <Input
        type="text"
        placeholder="Search for languages..."
        className="w-full bg-white"
        value={languageSearchQuery}
        onChange={(e) => dispatch(setLanguageSearchQuery(e.target.value))}
      />
    </div>
  );
}

export default LanguageSearchInput;
